import { forwardRef } from 'react'
import { Button as MUIButton } from '@mui/material'

/**
 * The app's Button.
 *
 * `forwardRef` is not decoration. MUI's `component` prop makes the receiving component the
 * rendered root, and MUI needs a ref on that root — for focus management, for Tooltip and
 * Popper anchors, and for the transition components. A plain function component cannot hold
 * one, so `<Link component={Button}>` in NonceForm logged "Invalid prop `component` supplied
 * to ForwardRef(Link)" on every render of /settings/nonce, and any Tooltip or Popper wrapped
 * around a Button would have silently failed to anchor.
 *
 * Forwarding here fixes it once for every call site rather than per usage.
 */
export const Button = forwardRef(({ children, ...props }, ref) => {
  return (
    <MUIButton ref={ref} {...props}>
      {children}
    </MUIButton>
  )
})

Button.displayName = 'Button'

export default Button
